export default __webpack_public_path__ + "static/media/loading.7e3ec421.svg";